import type { Settings } from '@brighterly/lib-core-types/customer/interfaces'
import type { ComputedRef } from 'vue'

import { useSettingsStore } from '@stores/settings'

interface SettingsReturn {
  settings: ComputedRef<Settings | null>
  hasData: ComputedRef<boolean>
  isInitialLoaded: ComputedRef<boolean>
}

export const useSettings = (): SettingsReturn => {
  const store = useSettingsStore()

  store.hydrateFromStorage()
  void store.ensure({ force: true })

  return {
    settings: computed(() => store.settings),
    hasData: computed(() => store.hasData),
    isInitialLoaded: computed(() => store.isInitialLoaded),
  }
}
